import React from 'react';

type DecimalInputProps = {
  value?: string | number | null;
  onChange: (value: string | number | null) => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

export const DecimalInput: React.FC<DecimalInputProps> = ({
  value,
  onChange,
  disabled = false,
  className = 'form-control form-control-solid',
  style = { backgroundColor: '#F5F8FA', width: '100px' }
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(',', '.');

    if (val === '') {
      onChange(null);
      return;
    }

    if (!/^\d+(\.\d?)?$/.test(val)) return;

    const num = parseFloat(val);
    if (num >= 1 && num <= 10) {
      // Спецкейс: не мешаем ввести "10."
      if (num === 10 && val[val.length - 1] === '.') return;

      onChange(val);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(',', '.');
    const num = parseFloat(val);

    if (!isNaN(num) && num >= 1 && num <= 10) {
      onChange(parseFloat(num.toFixed(1)));
    } else {
      onChange(null);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const val = e.currentTarget.value;

    if (['e', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }

    if ((e.key === '.' || e.key === ',') && (val.includes('.') || val.includes(','))) {
      e.preventDefault();
    }
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      className={className}
      style={style}
      disabled={disabled}
      value={value ?? ''}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
};
